import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const zigbeeNodeDescriptorsSlice = createSlice({
    name: 'zigbee_node_descriptors',
    initialState,
    reducers: {
        zigbeeNodeDescriptorsCleared: s => {
            for (const key in s) {
                delete s[key];
            }
            ;
        },
        zigbeeNodeDescriptorUpdated: (s, action) => {
            s[action.payload.id] = action.payload;
        },
        zigbeeNodeDescriptorDeleted: (s, action) => {
            delete s[action.payload];
        },
        zigbeeNodeDescriptorsReplaced: (s, action) => {
            const newState = {};
            for (const nd of action.payload) {
                newState[nd.id] = nd;
            }
            return newState;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            for (const o of action.payload.zigbee_node_descriptors) {
                newState[o.id] = o;
            }
            return newState;
        });
    },
});
export const { zigbeeNodeDescriptorsCleared, zigbeeNodeDescriptorUpdated, zigbeeNodeDescriptorDeleted, zigbeeNodeDescriptorsReplaced } = zigbeeNodeDescriptorsSlice.actions;
export default zigbeeNodeDescriptorsSlice.reducer;
